export default __webpack_public_path__ + "static/media/Darkstorm Sandals.408689a6.jpg";